import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageContext";
import { routes } from "@/i18n/routes";
import SeoMetadata from "@/components/SeoMetadata";

const Regulamin = () => {
  const { t, language } = useLanguage();

  const seoTitle = `${t("terms.title")} | Gendera Service`;
  const seoDescription = t("seo.description.terms" as any);

  return (
    <div className="min-h-screen bg-background">
      <SeoMetadata title={seoTitle} description={seoDescription} />
      <div className="bg-primary text-primary-foreground py-16 pt-40">
        <div className="container mx-auto px-4">
          <a href={`/${language}`}>
            <Button variant="ghost" className="text-primary-foreground hover:bg-primary-foreground/10 mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" size={16} />
              {t("privacy.backHome")}
            </Button>
          </a>
          <h1 className="text-4xl md:text-5xl font-bold">{t("terms.title")}</h1>
          <p className="text-primary-foreground/80 mt-4">{t("terms.lastUpdate")}</p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s1.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s1.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s2.title")}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">{t("terms.s2.text")}</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              {(["terms.s2.i1","terms.s2.i2","terms.s2.i3","terms.s2.i4","terms.s2.i5"] as const).map(k => <li key={k}>{t(k)}</li>)}
            </ul>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s3.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s3.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s4.title")}</h2>
            <p className="text-muted-foreground leading-relaxed mb-4">{t("terms.s4.p1")}</p>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s4.p2")}</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 mt-4">
              {(["terms.s4.i1","terms.s4.i2","terms.s4.i3"] as const).map(k => <li key={k}>{t(k)}</li>)}
            </ul>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s5.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s5.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s6.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s6.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s7.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s7.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s8.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s8.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s9.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t("terms.s9.text")}{" "}
              <a href={`/${language}/${routes.privacyPolicy[language]}`} className="text-accent hover:underline">{t("terms.s9.link")}</a>.
            </p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s10.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("terms.s10.text")}</p>
          </section>
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-foreground mb-4">{t("terms.s11.title")}</h2>
            <p className="text-muted-foreground leading-relaxed">
              {t("terms.s11.text")}<br />
              E-mail: biuro@gendera-service.pl<br />
              {t("contact.phone")}: +48 502 625 857<br />
              {t("contact.address")}: ul. Tysiąclecia 38, 62-002 Golęczewo, Polska
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Regulamin;
